import type { VisitorEntry } from '@/lib/types';

/** Legacy seed phones from older mock visitor data. */
const DEMO_VISITOR_PHONE_DIGITS = new Set([
  '919000000101',
  '919000000102',
  '919000000103',
  '919000000104',
  '9000000101',
  '9000000102',
  '9000000103',
  '9000000104',
]);

const DEMO_VISITOR_NAMES = new Set(['Maya Collins', 'Jordan Lee', 'Sophia Kim', 'Olivia Carter']);

export function isDemoVisitorEntry(visitor: Pick<VisitorEntry, 'visitorName' | 'visitorPhone'>) {
  const digits = visitor.visitorPhone.replace(/\D/g, '');
  return DEMO_VISITOR_PHONE_DIGITS.has(digits) || DEMO_VISITOR_NAMES.has(visitor.visitorName.trim());
}

export function stripDemoVisitors(visitors: VisitorEntry[]) {
  return visitors.filter((visitor) => !isDemoVisitorEntry(visitor));
}
